import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GalleryCard } from "@/components/Cards";

export default function Galleries() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/public/galleries").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-14 sm:pt-20" data-testid="galleries-page">
      <p className="eyebrow rise">Galleries</p>
      <h1 className="rise d1 mt-4 text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1a261f] max-w-3xl">Light, water and open space.</h1>
      <p className="rise d2 mt-5 text-[#5a665e] max-w-xl leading-relaxed">Tasteful, non-sexual photography from naturist places around Aotearoa. Everyone pictured has consented.</p>
      {items === null ? (
        <p className="mt-16 text-sm text-[#5a665e]">Loading…</p>
      ) : items.length === 0 ? (
        <p className="mt-16 text-[#5a665e]" data-testid="galleries-empty">No galleries yet — check back soon.</p>
      ) : (
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
          {items.map((g, i) => (
            <div key={g.id} className={i % 3 === 1 ? "lg:mt-16" : ""}><GalleryCard g={g} tall={i % 3 !== 1} /></div>
          ))}
        </div>
      )}
    </div>
  );
}
